import logger from './logger';
import apiCall from './apiCall';

const middlewares = [apiCall];

export default middlewares;
